// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseIssueEntity from './entities/case-issue.json';
import caseIssueMenu from '../pages/case-issue/menu.json';
import caseIssueFullForm from '../pages/case-issue/forms/full.json';
import caseIssueContextForm from '../pages/case-issue/forms/context.json';
import caseIssueMiniForm from '../pages/case-issue/forms/mini.json';
import caseIssueLookupForm from '../pages/case-issue/forms/lookup.json';
import caseIssueTableView from '../pages/case-issue/views/table.json';
import caseIssueCardsView from '../pages/case-issue/views/cards.json';
import caseIssueDashboardView from '../pages/case-issue/views/dashboard.json';

/** Тип запису «Проблема» зі сторінками пакета: меню, форми та подання з pages/case-issue/. */
export const caseIssueDefinition: IRecordTypeDefinition = {
  ...caseIssueEntity,
  views: assembleViewSet({
      table: caseIssueTableView,
      cards: caseIssueCardsView,
      dashboard: caseIssueDashboardView,
  }),
  form: caseIssueFullForm,
  forms: { full: caseIssueFullForm, context: caseIssueContextForm, mini: caseIssueMiniForm, lookup: caseIssueLookupForm },
  menu: caseIssueMenu,
} as IRecordTypeDefinition;
